import { IBuyin } from "../interface/buyin";
import axiosInstance from "./instance";

export const RequestGetBuyins = (addNotification: any, data?: any): Promise<IBuyin[]> => {
    return new Promise<IBuyin[]>((resolve, reject) => {
        let url = `/buyins/`;
        if (data) {
            url += "?";
            for (let [key, value] of Object.entries(data)) {
                url += key + '=' + value + "&";
            }
        }
        axiosInstance(addNotification).get(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

export const RequestGetBuyin = (addNotification: any, id: string): Promise<IBuyin> => {
    return new Promise<IBuyin>((resolve, reject) => {

        axiosInstance(addNotification).get(`/buyins/${id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            //  console.log(response);
            resolve(response)

        }).catch(exc => {
            //   console.log(exc);
            reject(exc);
        });
    })
}


export const RequestNewBuyin = (addNotification: any, thing: IBuyin): Promise<IBuyin> => {
    return new Promise<IBuyin>((resolve, reject) => {

        axiosInstance(addNotification).post(`/buyins/`, thing).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestDeleteBuyin = (addNotification: any, thing: IBuyin): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {

        axiosInstance(addNotification).delete(`/buyins/delete/${thing.id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestUpdateBuyin = (addNotification: any, user: IBuyin): Promise<IBuyin> => {
    return new Promise<IBuyin>((resolve, reject) => {

        axiosInstance(addNotification).patch(`/buyins/${user.id}`, user).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}

export const RequestBuyinFunction = (addNotification: any, func: string): Promise<any[] | any> => {
    return new Promise<any[]>((resolve, reject) => {
        let url = `/buyins/_func/${func}`;

        axiosInstance(addNotification).post(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

// eslint-disable-next-line
{/*<!-- OPTIONAL 1 -->*/ }

// eslint-disable-next-line
{/*<!-- OPTIONAL END -->*/ }
